import React, { useState, useEffect } from 'react';
import './_Modal.css';
const SendInvoiceModal = ({ isOpen, onClose, sendRequest, onInvoiceSent }) => {
    const [status, setStatus] = useState('sending'); // sending, sent, error
    const [error, setError] = useState(null);

    useEffect(() => {
        if (isOpen) {
            setStatus('sending');
            setError(null);
            sendRequest()
                .then(() => {
                    setStatus('sent');
                    onInvoiceSent();
                })
                .catch((err) => {
                    setStatus('error');
                    setError(err.message);
                });
        }
    }, [isOpen, sendRequest, onInvoiceSent]);

    if (!isOpen) {
        return null;
    }

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                {status === 'sending' && <p>Sending invoice...</p>}
                {status === 'error' && <p>Error: {error}</p>}
                {status === 'error' && <button className='cancel-button text-button'onClick={onClose}>Close</button>}
            </div>
        </div>
    );
};

export default SendInvoiceModal;
